import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { compose } from '@reduxjs/toolkit';

import type { BettingContextProps } from '../../types';
import type { ReduxState } from 'app/redux/types';

import { withinBettingContext } from 'app/contexts/betting';
import betSlipContext from 'app/modules/BetSlip/contexts/betSlip';

import { BetBlank } from '../BetRepresentation';

import styles from './Stake.module.scss';

// ---

type StakeBlankProps = {
  // TODO: write types, if you have some free time please :)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const StakeBlank: FC<StakeBlankProps> = ({ className, conflictedIds, dispatch }) => {
  const handleClick = () => {
    if (!conflictedIds) {
      return;
    }
    dispatch(betSlipContext.actions.conflicts(Date.now()));
  };

  return (
    <div className={classNames(styles.stake, className, 'disabled')}
         onClick={handleClick}>
      <BetBlank />
      <BetBlank />
    </div>
  );
};

const mapStateToProps = (state: ReduxState, {
  $betting: {
    staking,
  },
}: BettingContextProps) => ({
  conflictedIds: staking.selectors.selectAllConflictedIds(state),
});

export default compose<FC<StakeBlankProps>>(
  withinBettingContext,
  connect(mapStateToProps),
)(StakeBlank);
